import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useState, useContext, useCallback, useMemo, useRef } from 'react';
import Toast from '@/components/notifications/Toast';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ToastContext = /*#__PURE__*/createContext({
  addToast: () => undefined,
  removeToast: () => undefined
});
const DEFAULT_POSITION = 'top-right';
let id = 1;
export const ToastProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: toasts,
    1: setToasts
  } = useState([]);
  const toastsVisibilityById = useRef({});
  const toastsByPosition = useMemo(() => toasts.reduce((acc, toast) => {
    const position = toast.position || DEFAULT_POSITION;
    acc[position] = acc[position] || [];
    acc[position].push(toast);
    return acc;
  }, {}), [toasts]);
  const isVisible = useCallback(toastId => {
    return toastsVisibilityById.current[toastId] ?? false;
  }, []);
  const addToast = useCallback(toast => {
    // Prevent duplicate toasts
    if (toast.toastId && !isVisible(toast.toastId)) {
      toastsVisibilityById.current[toast.toastId] = true;
    } else if (toast.toastId && isVisible(toast.toastId)) {
      return;
    }

    setToasts(toasts => [...toasts, _objectSpread({
      id: id++
    }, toast)]);
  }, [setToasts, isVisible]);
  const removeToast = useCallback(id => {
    setToasts(toasts => toasts.filter(t => {
      // Remove toast from visibility map
      if (t.id === id && t.toastId) {
        toastsVisibilityById.current[t.toastId] = false;
      }

      return t.id !== id;
    }));
  }, [setToasts]);
  return /*#__PURE__*/_jsxs(ToastContext.Provider, {
    value: {
      addToast,
      removeToast
    },
    children: [Object.entries(toastsByPosition).map(_ref2 => {
      let [position, toasts] = _ref2;
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread({
          position: 'fixed',
          maxWidth: '24rem',
          width: '100%',
          zIndex: 50
        }, getToastPosition(position)),
        children: toasts.map((toast, i) => /*#__PURE__*/_jsx(Toast, {
          toast: toast
        }, i))
      }, `toast-${position}`);
    }), children]
  });
};

const getToastPosition = position => {
  switch (position) {
    case 'topRight':
      return {
        top: 0,
        right: 0
      };

    case 'bottomMiddle':
      return {
        bottom: 8,
        left: '50%',
        transform: 'translateX(-50%)'
      };

    case 'bottomRight':
      return {
        bottom: 8,
        right: 0
      };

    default:
      return {
        top: 0,
        right: 0
      };
  }
};

export const useToast = () => {
  return useContext(ToastContext);
};